import { generateId } from '@freelancer/datastore/testing/helpers';
import type { CustomerWebhook } from '../customer-webhooks';
import type {
  AddressResponse,
  CustomerAccountType,
  CustomerTaxNumberResponse,
  CustomerVerificationResponse,
} from './customers.backend-model';
import type {
  Customer,
  CustomerCompany,
  CustomerElectronicVerificationStatus,
  CustomerEmailVerification,
} from './customers.model';
import type { DisbursementMethod } from '../disbursement-methods/disbursement-methods.model';

export interface GenerateCustomerOptions {
  readonly id?: number;
  readonly accountType?: CustomerAccountType;
  readonly address?: AddressResponse;
  readonly company?: CustomerCompany;
  readonly customerEmailVerification?: CustomerEmailVerification;
  readonly dateOfBirth?: number;
  readonly disbursementMethods?: readonly Omit<DisbursementMethod, 'isValid'>[];
  readonly displayName?: string;
  readonly electronicVerification?: CustomerElectronicVerificationStatus;
  readonly email?: string;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly middleName?: string;
  readonly phoneNumber?: string;
  readonly shippingAddress?: AddressResponse;
  readonly taxNumbers?: readonly CustomerTaxNumberResponse[];
  readonly username?: string;
  readonly verification?: CustomerVerificationResponse;
  readonly webhooks?: readonly CustomerWebhook[];
}

export function generateCustomerObject(
  {
    id,
    accountType,
    address,
    company,
    customerEmailVerification,
    dateOfBirth,
    disbursementMethods,
    displayName,
    electronicVerification,
    email,
    firstName,
    lastName,
    middleName,
    phoneNumber,
    shippingAddress,
    taxNumbers,
    username,
    verification,
    webhooks,
  }: GenerateCustomerOptions = {
    email: 'test@example.com',
    verification: notVerified(),
    customerEmailVerification: {
      verified: false,
    },
    electronicVerification: {
      available: false,
      documentsSupported: [],
    },
  },
): Customer {
  return {
    id: id ?? generateId(),
    accountType: accountType ?? 'individual',
    address,
    company,
    customerEmailVerification: customerEmailVerification ?? {
      verified: false,
    },
    dateOfBirth,
    disbursementMethods,
    displayName,
    electronicVerification: electronicVerification ?? {
      available: false,
      documentsSupported: [],
    },
    email: email ?? 'uitest@escrow.com',
    firstName,
    lastName,
    middleName,
    phoneNumber,
    shippingAddress,
    taxNumbers,
    username,
    verification: verification ?? notVerified(),
    webhooks,
  };
}

function notVerified(): CustomerVerificationResponse {
  return {
    personal: {
      status: 'not_verified',
    },
    company: {
      status: 'not_verified',
    },
    extended: {
      status: 'not_verified',
    },
  };
}
